export enum CsvExportOptionsEnum {
  Profiles,
  ProfilesAllExperience,
  ProfilesAllEducation,
  ProfilesAllEduAndExp,
  CompaniesFromProject,
  CompaniesFromProfileExperience,
  CurrentCompaniesFromProfile
}
